window.VdSelect = {
    countryLabel: '',
    languageLabel: '',

    /**
     * Initialization of Select
     *
     * @param select
     */
    init: function (select) {
        this.create(select);
    },

    /**
     * Destroying Custom Select
     *
     * @param select
     */
    destroy: function (select) {
        const selectParent = select.parentNode;
        selectParent.querySelector('.select__custom').remove();
    },

    /**
     * Trigger Custom Select
     *
     * @param select
     */
    create: function (select) {
        const selectParent = select.parentNode;
        const selectChild = select.childNodes;
        const selectNameAttr = select.getAttribute('name');
        const currentSelect = select.querySelector('option[selected]');
        const selectIdentification = `vd__select--${selectNameAttr}`;

        /** Add own Identification to original Select by Name Attribute **/
        select.classList.add(selectIdentification);

        /** Create custom Select Wrapper **/
        let customSelectWrapper = document.createElement('div');
        customSelectWrapper.classList.add('select__custom');
        customSelectWrapper.classList.add(`select__custom--${selectNameAttr}`);


        /** Create custom Select Wrapper for Current Selected Item **/
        let customSelectCurrent = document.createElement('span');
        customSelectCurrent.classList.add('select__custom--current');
        customSelectCurrent.classList.add('icon-arrow_down');

        /** Add Event Listener to Current Wrapper for Toggle **/
        customSelectCurrent.addEventListener('click', () => {
            customSelectWrapper.classList.toggle('select__custom--toggled');
        });

        /** Add all Attributes to current Wrapper for current Selected option **/
        addAllAttributes(currentSelect, customSelectCurrent);

        /** Truncate custom current Select String **/
        window.VdSelect[`${selectNameAttr}Label`] = customSelectCurrent.innerText;
        truncateAndResizeTruncate(customSelectCurrent, '10');

        /** Create custom Select List Wrapper **/
        let customSelectList = document.createElement('ul');
        customSelectList.classList.add('select__custom--list');

        /** Create Items for custom Select List with his Attributes **/
        selectChild.forEach(child => {
            const newLi = document.createElement('li');
            const childAttr = child.attributes;

            /** Create All Attributes for Li Element **/
            for(let i = 0; i < child.attributes.length; i++) {
                const newAttr = document.createAttribute(childAttr[i].name);

                newAttr.value = childAttr[i].value;
                newLi.setAttributeNode(newAttr);
            }

            /** Create Span for Li Element Text **/
            const newSpan = document.createElement('span');
            newSpan.innerText = child.innerText;
            newLi.append(newSpan);

            customSelectList.append(newLi);
        });

        /** Append all Wrappers in their positions **/
        customSelectWrapper.append(customSelectCurrent);
        customSelectWrapper.append(customSelectList);
        selectParent.append(customSelectWrapper);

        /** Add Event Listener for every Item in custom Select List Wrapper **/
        customSelectWrapper.querySelectorAll('li').forEach(item => {
            item.addEventListener('click', () => {
                const newSelectedOption = select.querySelector(`option[value="${item.getAttribute('value')}"]`);

                /** After Selection, close the List **/
                customSelectWrapper.classList.toggle('select__custom--toggled');

                /** Remove Selected option to current Element **/
                select.querySelector('option[selected]').removeAttribute('selected');

                /** Set to new Selected Option the Attribute selected, value  & trigger change Event **/
                newSelectedOption.setAttribute('selected','');
                select.value = item.getAttribute('value');
                select.dispatchEvent(new Event('change'));

                /** Exchange the current custom Select Value **/
                addAllAttributes(newSelectedOption, customSelectCurrent);

                /** Truncate custom current Select String **/
                window.VdSelect[`${selectNameAttr}Label`] = customSelectCurrent.innerText;
                truncateAndResizeTruncate(customSelectCurrent, '10');
            });
        });

        /** Set all Option Attributes from Selected one to another custom current Select Wrapper **/
        function addAllAttributes(fromElement, toElement) {
            for(let i = 0; i < fromElement.attributes.length; i++) {
                const newAttr = document.createAttribute(fromElement.attributes[i].name);
                newAttr.value = fromElement.attributes[i].value;
                toElement.setAttributeNode(newAttr);
            }

            toElement.innerText = fromElement.innerText;
        }

        /**
         * Single truncateString() Call for current Value &&
         * Creating a Listener on Resize for truncateString()
         *
         * @param selector
         * @param length
         */
        function truncateAndResizeTruncate(selector, length) {
            truncateString(selector, length);

            window.addEventListener('resize', function () {
                truncateString(selector, length);
            });
        }

        /**
         * Truncate String to an decided Length and add dots
         * @param selector
         * @param length
         */
        function truncateString(selector, length) {
            const text = selector.innerText;

            if(window.innerWidth > 767 && selectNameAttr === 'country') {
                selector.innerText = ((text.length > length) ? text.substring(0 , length) + ' ...' : text);
            }
            else {
                selector.innerText = window.VdSelect[`${selectNameAttr}Label`];
            }
        }
    }
}
